import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/layout/Layout';
import { Card, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { BookOpen, ArrowLeft } from 'lucide-react';
import FunctionManagement from '../../components/admin/FunctionManagement';

const AdminFunctionsPage = () => {
  const navigate = useNavigate();
  
  return (
    <Layout>
      <div className="page-transition">
        <Button
          variant="ghost"
          onClick={() => navigate('/admin/content')}
          className="mb-4"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Content Management
        </Button>
        
        <Card className="mb-6">
          <CardHeader className="bg-gradient-to-r from-[#14B8A6]/5 to-white">
            <div className="flex items-center gap-3">
              <div className="p-3 bg-[#14B8A6] rounded-lg">
                <BookOpen className="w-6 h-6 text-white" />
              </div>
              <div>
                <CardTitle className="text-2xl">Function Management</CardTitle>
                <CardDescription>Manage question functions by grade and function number</CardDescription>
              </div>
            </div>
          </CardHeader>
        </Card>
        
        <FunctionManagement />
      </div>
    </Layout>
  );
};

export default AdminFunctionsPage;
